// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.context {
    font-family: Arial, sans-serif;
    margin: 0;
    margin-top: 10%;
    padding: 0;
}

.contextTitle .post-title{
    font-size: 25px;
    font-weight: bolder;
}

.titleSeparator {
    max-width: 30%;
    border: none; /* 기본 테두리 제거 */
    height: 2px; /* 선의 두께 */
    background-color: #a7c898; /* 선의 색상 */
    margin-top: 15px; /* 제목과 선 사이의 여백 */
}

.search-container {
    display: flex;
    justify-content: flex-start; /* 왼쪽 정렬을 기본으로 함 */
    align-items: center;
    margin-bottom: 10px;
    margin-top: 40px;
    margin-left: 900px;
}

.search-input {
    padding: 10px;
    font-size: 16px;
    width: 300px;
    border: 1px solid #c6e1fb;
    border-radius: 4px;
    margin-right: 10px;
}

.search-button {
    padding: 10px 20px;
    font-size: 16px;
    background-color: rgb(198, 225, 251);
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.search-button:hover {
    background-color: rgba(106, 170, 125, 0.69);
}

.contentSeparator{
    max-width: 60%;
    border: none; /* 기본 테두리 제거 */
    height: 1px; /* 선의 두께 */
    background-color: rgb(183, 210, 245); /* 선의 색상 */
    margin-top: 15px; /* 제목과 선 사이의 여백 */
    margin-bottom: 40px;
}

/* 게시글 박스 배치 */
.posts-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr); /* 가로로 3개씩 배치 */
    gap: 3px; /* 박스 간격 */
    justify-items: center;
    padding: 30px;
    width: 70%;
    margin: 0 auto;
}

/* 게시글 박스 디자인 */
.post-box {
    width: 250px; /* 박스의 너비 */
    height: 350px; /* 박스의 높이 */
    overflow: hidden;
    text-align: center;
    padding-bottom: 40px;
}

/* 게시글 이미지 */
.pagination {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    margin-bottom: 90px;
}

.pagination-button {
    border: 1px solid #ffffff;
    padding: 10px 15px;
    margin: 0 5px;
    background-color: #ffffff;
    cursor: pointer;
    font-size: 13px;
    color: #6c757d;
}

.pagination-button.active {
    background-color: #a7c898;
    color: #fff;
    border: none;
}

.pagination-button:hover {
    background-color: #e2e6ea;
}

.post-image-container {
    width: 100%;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.default-image {
    width: 100%;
    height: 250px;
    background-color: black;
}

.post-image {
    width: 100%;
    height: 250px;
    object-fit: cover;
}

.post-detail {
    max-width: 800px;
    margin: 20px auto;
    padding: 20px;
}

.post-metadata {
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #555;

    margin-top: 10px;
    margin-bottom: 30px;
}

.post-metadata span {
    margin-right: 10px;
}

/* 게시글 작성 날짜 */
.post-date {
    color: #888;
    font-size: 12px;
    margin-bottom: 40px;
    margin-top: 0;
}

.back-button {
    margin-top: 100px;
    padding: 10px 30px;
    font-size: 16px;
    background-color: rgb(255, 255, 255);
    color: rgb(104, 104, 104); /* 텍스트 색상 변경 */
    border: 1px solid #a5a5a5; /* border를 solid로 명확히 지정 */
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease;
}

.back-button:hover{
    background-color: rgba(145, 145, 145, 0.2);
    color: #535353;
}

.post-content {
    font-size: 18px;
    line-height: 1.6;
    color: #333;
    margin-top: 45px;
    white-space: pre-wrap;
}

.post-images {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    overflow: hidden;
}

.image-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}

.current-image {
    width: 100%;
    height: auto;
    object-fit: contain;
}

.prev-btn,
.next-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(0, 0, 0, 0.3);
    color: white;
    border: none;
    padding: 8px;
    cursor: pointer;
    border-radius: 50%;
    font-size: 15px;
}

.prev-btn {
    left: 10px;
}

.next-btn {
    right: 10px;
}

.prev-btn:hover,
.next-btn:hover {
    background: rgba(0, 0, 0, 0.8);
}

.like-section {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
}

.like-button {
    background-color: transparent;
    border: none;
    color: #e63946;
    font-size: 16px;
    cursor: pointer;
    padding: 5px 10px;
    transition: transform 0.2s ease;
}

.like-button:hover {
    transform: scale(1.1);
}

.like-count {
    margin-left: 8px;
    font-size: 16px;
    color: #888888;
}

.like-icon {
    width: 24px; /* 이미지 크기 설정 */
    height: 24px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Announcement/styles.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,UAAU;AACd;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,YAAY,EAAE,cAAc;IAC5B,WAAW,EAAE,UAAU;IACvB,yBAAyB,EAAE,UAAU;IACrC,gBAAgB,EAAE,iBAAiB;AACvC;;AAEA;IACI,aAAa;IACb,2BAA2B,EAAE,kBAAkB;IAC/C,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,oCAAoC;IACpC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,cAAc;IACd,YAAY,EAAE,cAAc;IAC5B,WAAW,EAAE,UAAU;IACvB,oCAAoC,EAAE,UAAU;IAChD,gBAAgB,EAAE,iBAAiB;IACnC,mBAAmB;AACvB;;AAEA,cAAc;AACd;IACI,aAAa;IACb,qCAAqC,EAAE,eAAe;IACtD,QAAQ,EAAE,UAAU;IACpB,qBAAqB;IACrB,aAAa;IACb,UAAU;IACV,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,YAAY,EAAE,WAAW;IACzB,aAAa,EAAE,WAAW;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,WAAW;;IAEX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,cAAc;AACd;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,oCAAoC;IACpC,yBAAyB,EAAE,cAAc;IACzC,yBAAyB,EAAE,0BAA0B;IACrD,kBAAkB;IAClB,eAAe;IACf,uDAAuD;AAC3D;;AAEA;IACI,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,8BAA8B;IAC9B,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW,EAAE,cAAc;IAC3B,YAAY;AAChB","sourcesContent":[".context {\n    font-family: Arial, sans-serif;\n    margin: 0;\n    margin-top: 10%;\n    padding: 0;\n}\n\n.contextTitle .post-title{\n    font-size: 25px;\n    font-weight: bolder;\n}\n\n.titleSeparator {\n    max-width: 30%;\n    border: none; /* 기본 테두리 제거 */\n    height: 2px; /* 선의 두께 */\n    background-color: #a7c898; /* 선의 색상 */\n    margin-top: 15px; /* 제목과 선 사이의 여백 */\n}\n\n.search-container {\n    display: flex;\n    justify-content: flex-start; /* 왼쪽 정렬을 기본으로 함 */\n    align-items: center;\n    margin-bottom: 10px;\n    margin-top: 40px;\n    margin-left: 900px;\n}\n\n.search-input {\n    padding: 10px;\n    font-size: 16px;\n    width: 300px;\n    border: 1px solid #c6e1fb;\n    border-radius: 4px;\n    margin-right: 10px;\n}\n\n.search-button {\n    padding: 10px 20px;\n    font-size: 16px;\n    background-color: rgb(198, 225, 251);\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.search-button:hover {\n    background-color: rgba(106, 170, 125, 0.69);\n}\n\n.contentSeparator{\n    max-width: 60%;\n    border: none; /* 기본 테두리 제거 */\n    height: 1px; /* 선의 두께 */\n    background-color: rgb(183, 210, 245); /* 선의 색상 */\n    margin-top: 15px; /* 제목과 선 사이의 여백 */\n    margin-bottom: 40px;\n}\n\n/* 게시글 박스 배치 */\n.posts-container {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr); /* 가로로 3개씩 배치 */\n    gap: 3px; /* 박스 간격 */\n    justify-items: center;\n    padding: 30px;\n    width: 70%;\n    margin: 0 auto;\n}\n\n/* 게시글 박스 디자인 */\n.post-box {\n    width: 250px; /* 박스의 너비 */\n    height: 350px; /* 박스의 높이 */\n    overflow: hidden;\n    text-align: center;\n    padding-bottom: 40px;\n}\n\n/* 게시글 이미지 */\n.pagination {\n    display: flex;\n    justify-content: center;\n    margin-top: 20px;\n    margin-bottom: 90px;\n}\n\n.pagination-button {\n    border: 1px solid #ffffff;\n    padding: 10px 15px;\n    margin: 0 5px;\n    background-color: #ffffff;\n    cursor: pointer;\n    font-size: 13px;\n    color: #6c757d;\n}\n\n.pagination-button.active {\n    background-color: #a7c898;\n    color: #fff;\n    border: none;\n}\n\n.pagination-button:hover {\n    background-color: #e2e6ea;\n}\n\n.post-image-container {\n    width: 100%;\n    height: 200px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.default-image {\n    width: 100%;\n    height: 250px;\n    background-color: black;\n}\n\n.post-image {\n    width: 100%;\n    height: 250px;\n    object-fit: cover;\n}\n\n.post-detail {\n    max-width: 800px;\n    margin: 20px auto;\n    padding: 20px;\n}\n\n.post-metadata {\n    display: flex;\n    justify-content: center;\n    font-size: 14px;\n    color: #555;\n\n    margin-top: 10px;\n    margin-bottom: 30px;\n}\n\n.post-metadata span {\n    margin-right: 10px;\n}\n\n/* 게시글 작성 날짜 */\n.post-date {\n    color: #888;\n    font-size: 12px;\n    margin-bottom: 40px;\n    margin-top: 0;\n}\n\n.back-button {\n    margin-top: 100px;\n    padding: 10px 30px;\n    font-size: 16px;\n    background-color: rgb(255, 255, 255);\n    color: rgb(104, 104, 104); /* 텍스트 색상 변경 */\n    border: 1px solid #a5a5a5; /* border를 solid로 명확히 지정 */\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.back-button:hover{\n    background-color: rgba(145, 145, 145, 0.2);\n    color: #535353;\n}\n\n.post-content {\n    font-size: 18px;\n    line-height: 1.6;\n    color: #333;\n    margin-top: 45px;\n    white-space: pre-wrap;\n}\n\n.post-images {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    width: 100%;\n    max-width: 600px;\n    margin: 0 auto;\n    overflow: hidden;\n}\n\n.image-container {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.current-image {\n    width: 100%;\n    height: auto;\n    object-fit: contain;\n}\n\n.prev-btn,\n.next-btn {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    background: rgba(0, 0, 0, 0.3);\n    color: white;\n    border: none;\n    padding: 8px;\n    cursor: pointer;\n    border-radius: 50%;\n    font-size: 15px;\n}\n\n.prev-btn {\n    left: 10px;\n}\n\n.next-btn {\n    right: 10px;\n}\n\n.prev-btn:hover,\n.next-btn:hover {\n    background: rgba(0, 0, 0, 0.8);\n}\n\n.like-section {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 30px;\n}\n\n.like-button {\n    background-color: transparent;\n    border: none;\n    color: #e63946;\n    font-size: 16px;\n    cursor: pointer;\n    padding: 5px 10px;\n    transition: transform 0.2s ease;\n}\n\n.like-button:hover {\n    transform: scale(1.1);\n}\n\n.like-count {\n    margin-left: 8px;\n    font-size: 16px;\n    color: #888888;\n}\n\n.like-icon {\n    width: 24px; /* 이미지 크기 설정 */\n    height: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
